import * as React from "react";

export function MoneyBarras(props) {
  return (
    <svg
      width={41}
      height={41}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_29_70)" fill="#FAFAFA">
        <path d="M6.43 16.773H1.864c-1.03 0-1.864.834-1.864 1.864v20.5C0 40.165.835 41 1.864 41H6.43c1.03 0 1.863-.835 1.863-1.863v-20.5c0-1.03-.834-1.864-1.863-1.864zM17.332 22.363h-4.566c-1.03 0-1.864.834-1.864 1.864v14.908c0 1.03.834 1.864 1.865 1.864h4.565c1.03 0 1.864-.835 1.864-1.864V24.227c0-1.03-.834-1.864-1.864-1.864zM28.233 22.363h-4.566c-1.029 0-1.863.834-1.863 1.864v14.908c0 1.03.834 1.864 1.864 1.864h4.565c1.03 0 1.864-.835 1.864-1.864V24.227c0-1.03-.833-1.864-1.864-1.864zM39.136 16.773H34.57c-1.03 0-1.864.834-1.864 1.864v20.5c0 1.029.834 1.863 1.864 1.863h4.566c1.03 0 1.864-.836 1.864-1.863v-20.5c0-1.03-.835-1.864-1.864-1.864zM21.044 11.227v3.355c1.015-.067 2.085-.543 2.085-1.66 0-1.154-1.173-1.492-2.085-1.695zM18.125 7.212c0 .848.631 1.338 1.902 1.593V5.77c-1.155.034-1.902.712-1.902 1.442z" />
        <path d="M20.5 0c-5.652 0-10.25 4.599-10.25 10.25 0 5.65 4.598 10.248 10.25 10.248S30.75 15.9 30.75 10.25C30.75 4.599 26.152 0 20.5 0zm.544 16.312v1.05c0 .288-.222.576-.512.576-.286 0-.505-.288-.505-.577v-1.05c-2.864-.069-4.288-1.78-4.288-3.12 0-.676.409-1.066 1.05-1.066 1.897 0 .421 2.338 3.238 2.456V11.04c-2.512-.457-4.034-1.559-4.034-3.44 0-2.303 1.916-3.491 4.034-3.558V3.14c0-.29.22-.577.505-.577.29 0 .512.288.512.577v.903c1.32.035 4.032.864 4.032 2.526 0 .66-.493 1.05-1.07 1.05-1.103 0-1.087-1.813-2.962-1.847v3.22c2.236.475 4.217 1.135 4.217 3.745 0 2.27-1.694 3.421-4.217 3.576z" />
      </g>
      <defs>
        <clipPath id="clip0_29_70">
          <path fill="#fff" d="M0 0H41V41H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
